import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setlayoutLiveTracking } from '../../features/layout/layoutSlice';
import { liveTrackinglayoutSelector, } from '../../features/layout/layoutSlice';
import LastEvent from './LastEvent';
import EventTicker from './EventTicker';



const EventFooter = () => {
    const dispatch = useDispatch();
    const dimentions = useSelector(liveTrackinglayoutSelector);
    //console.log("Event Footer Rolling");

    useEffect(() => {
        const liveTrackingLayoutPayload = {
            sidebarWidthratio: 0.25,
            minFooter: 80
        };
        //console.log("disptach event footer layout");
        dispatch(setlayoutLiveTracking(liveTrackingLayoutPayload));

    }, [dispatch]);
    const [move, setMove] = useState(true);



    return (
        <div
            style={{
                ...dimentions.footer,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
            }}
            onMouseEnter={() => setMove(false)}
            onMouseLeave={() => setMove(true)}
        >
            <div style={dimentions.footer}>
                <div style={{ marginTop: '15px' }}>
                    <LastEvent />
                </div>
                <div style={{ marginTop: '15px' }}>
                    <EventTicker style={dimentions.footer} move={move} />
                </div>

            </div>
        </div>



    );
}

export default React.memo(EventFooter);

/**
 * //console.log("Event", eventContent[`${eventId}`].event_desc, rack[`${eventContent[`${eventId}`].assetID}`].vehicleDevice.regn, moment(eventContent[`${eventId}`].event_time).format('Do MMM YY hh:mm:ss A'));
 */

